import _ from 'lodash';

import COMMON_IMPORTS from './common.imports';

import './persons.bundle.scss';

import commonFiltersMod from './common/filters';
import personsModule from './persons/persons.component';
import defaultConfigs from './common.config';
import defaultRuns from './common.run';
import translationServiceMod from './common/translation.service';

let mod = angular.module('personsMain', _.union(
  COMMON_IMPORTS,
  defaultConfigs.imports,
  defaultRuns.imports,
  [
    personsModule,
    translationServiceMod,
    commonFiltersMod
  ]
)).controller('PersonsBundleController', function ($window, $scope, $compile, $element, TranslationService) {
  TranslationService.waitForTranslations().finally(() => {
    const service = $element[0].dataset['service'];
    const location = $element[0].dataset['location'];

    $scope.onPersonSelected = person => $window.location.href = person.url;

    const element = angular.element(
      `<persons service-id="${service}"
                location-id="${location}"
                person-selected-callback="onPersonSelected(person)">
      </persons>`
    );
    $compile(element)($scope);

    // Render the persons widget
    $element.append(element);
  });
});

mod = defaultConfigs(mod);
mod = defaultRuns(mod);

export default mod.name;
